import React from 'react';
import { connect } from 'react-redux';
import { VscGraph } from "react-icons/vsc";

class BackButton extends React.Component {

    render() {
        let url = "/project-page?project_id=" + this.props.projectData.id
        let target = '_self'
        if (window.frameElement !== null) {
            target = '_blank'
        }

        if (this.props.projectData.attributes.published) {
            url = "/"
            target = '_blank'
        }
    
        return(
            <a className='web-view d-flex align-items-center' style={{ maxWidth:'110px'}} href={url} target={target}>
                <VscGraph size={25}/>
                <p style={{ fontSize:'12px', width: '80px'}} className='pl-2 m-0 text-center d-flex align-items-center'>Vista Web</p>
            </a>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        projectData: state.projectData
    }
}

export default connect(mapStateToProps)(BackButton);